<template>
	<div class="tag" :class="[optionClass, {'square': square}]" :style="{'background': background, 'font-weight': bold}">
		<slot/>
	</div>
</template>

<script>
export default {
	props: {
		background: {
			type: String,
			default: ''
		},
		optionClass: {
			type: String,
			default: ''
		},
		square: {
			type: Boolean,
			default: false
		},
		bold: {
			type: Number,
			default: 400
		}
	}
}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>